import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PaginatorResult } from '@shared/interfaces/paginator_interface';
import { ApiResponse } from '@shared/interfaces/wrap-api-response.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Coupon, CreateCouponDTO, updateCouponDTO } from './interfaces/coupon.interface';
import { MessageDto } from 'src/app/brands/data-access/interfaces/services-interface';

@Injectable({
	providedIn: 'root'
})
export class CouponService {
	private http = inject(HttpClient);

	private url = environment.API_DOMAIN + environment.SERVICES.COUPON;

	public getAllCoupons(
		page: number = 1,
		pageSize: number = 10,
		filters: { [key: string]: IObj } = {}
	): Observable<ApiResponse<PaginatorResult<Coupon>>> {
		const params: Record<string, string> = {
			page: page.toString(),
			pageSize: pageSize.toString(),
			sortOrder: 'DESC',
			...filters
		};
		return this.http.get<ApiResponse<PaginatorResult<Coupon>>>(`${this.url}/list`, { params });
	}

	public create(coupon: CreateCouponDTO): Observable<ApiResponse<boolean>> {
		return this.http.post<ApiResponse<boolean>>(`${this.url}/create`, coupon);
	}

	public updateStatus(coupon: Pick<Coupon, 'id' | 'enabled'>): Observable<ApiResponse<Coupon>> {
		return this.http.put<ApiResponse<Coupon>>(`${this.url}/update-status/${coupon.id}`, { status: coupon.enabled });
	}

	public updateDataCoupon(coupon: updateCouponDTO): Observable<ApiResponse<Coupon>> {
		const { id, ...payload } = coupon;
		return this.http.put<ApiResponse<Coupon>>(`${this.url}/update/${id}`, payload);
	}

	public deleteBrand(id: number): Observable<ApiResponse<MessageDto>> {
		return this.http.delete<ApiResponse<MessageDto>>(`${this.url}/delete/${id}`);
	}

	public getById(id: number): Observable<ApiResponse<Coupon>> {
		return this.http.get<ApiResponse<Coupon>>(`${this.url}/${id}`);
	}

	public exportCouponsToExcel(filters: { [key: string]: IObj } = {}): Observable<Blob> {
		const params: { [key: string]: string } = {};
		Object.keys(filters).forEach((key) => {
			params[key] = filters[key].toString();
		});

		return this.http.get(`${this.url}/download`, {
			params,
			responseType: 'blob'
		});
	}
}
